// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2YQE0","alertIcon":"ConfirmModal_alertIcon__329LF"};